'use strict';

angular.module('mean.projects').factory('updateMaterialColorService', ['$filter', 'ProjectMaterials', '$q', 'taskService',
    function($filter, ProjectMaterials, $q, taskService) {

        //parameter one: main project information
        //parameter two: material to update
        var update = function(project, task, lot, material) {
            // look for reports by supplier, submitted == false, project_id, 
            // trade, company_code, phase, task_code
            // maybe project_task_id, lot data
            ProjectMaterials.query({ 'project_id': project._id, 
                'trade': task.trade, 
                'company_code': task.company_code,
                'submitted': false,
                'phase': task.phase,
                'task_code': task.task_code,
                'supplier': material.supplier }, function(reports) {
                _.each(reports, function(report) {
                    var update = $filter('filter')(report.materials, {
                        'name': material.name,
                        'lot': lot.number,
                        'plan_code': task.plan_code,
                        'foreman_note': material.foreman_note }, true);

                    if(update.length === 1) {
                        update[0].color_code = lot.current;

                        report.$update();
                    }
                });
            });
        };

        var updateFromBid = function(project, bid_task, lot, material) {
            // look for reports by supplier, submitted == false, project_id, 
            // trade, company_code, phase, task_code
            // maybe project_task_id, lot data
            console.log('nothing done at this time');
            // ProjectMaterials.query({ 'project_id': project._id, 
            //     'trade': bid_task.trade, 
            //     'company_code': bid_task.company_code,
            //     'submitted': false,
            //     'phase': bid_task.phase,
            //     'task_code': bid_task.task_code,
            //     'supplier': material.supplier }, function(reports) {
            //     _.each(reports, function(report) {
            //         var update = $filter('filter')(report.materials, {
            //             'name': material.name,
            //             'plan_code': task.plan_code,
            //             'foreman_note': material.foreman_note }, true);

            //         if(update.length === 1) {
            //             update[0].color_code = lot.current;

            //             report.$update();
            //         }
            //     });
            // });
        };

        return {
            update: update,
            updateFromBid: updateFromBid
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/update-material-color-service.js